var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1638 12.3799H10.2031C10.1281 12.3799 10.0656 12.4424 10.0656 12.5174V13.621H2.37651V2.37455H10.0674V3.47813C10.0674 3.55313 10.1299 3.61563 10.2049 3.61563H11.1656C11.2406 3.61563 11.3031 3.55491 11.3031 3.47813V1.68884C11.3031 1.38527 11.0585 1.14062 10.7549 1.14062H1.69079C1.38722 1.14062 1.14258 1.38527 1.14258 1.68884V14.3067C1.14258 14.6103 1.38722 14.8549 1.69079 14.8549H10.7531C11.0567 14.8549 11.3013 14.6103 11.3013 14.3067V12.5174C11.3013 12.4406 11.2388 12.3799 11.1638 12.3799Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7304 7.3548H7.12329C7.04472 7.3548 6.98043 7.41909 6.98043 7.49766V8.49766C6.98043 8.57623 7.04472 8.64052 7.12329 8.64052H12.7304V9.99766C12.7304 10.1173 12.8679 10.1852 12.9626 10.1102L15.4965 8.11016C15.5136 8.0968 15.5274 8.07972 15.5369 8.06023C15.5464 8.04074 15.5513 8.01934 15.5513 7.99766C15.5513 7.97598 15.5464 7.95458 15.5369 7.93509C15.5274 7.9156 15.5136 7.89852 15.4965 7.88516L12.9626 5.88516C12.8697 5.81016 12.7304 5.87802 12.7304 5.99766V7.3548Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.7d9b6383f9b18b8bc28ded78adfacdcb.svg";
export { ForwardRef as ReactComponent };